export enum SchufaReportType {
  IDENTITY = 'IDENTITY',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  CREDIT_RATING = 'CREDIT_RATING'
}
